import Helpers from "./helpers";

import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import intersect from "@alpinejs/intersect";
import persist from "@alpinejs/persist";

import Swiper from "swiper/bundle";
import "swiper/css/bundle";

import Masonry from "masonry-layout";
import ImagesLoaded from "imagesloaded";

// import GoogleMap from "./map";

// Init alpine plugins
Alpine.plugin(collapse);
Alpine.plugin(intersect);
Alpine.plugin(persist);
Alpine.start();

new Swiper('.event-carousel', {
  loop: true,
  centeredSlides: true,
  slidesPerView: 1,
  spaceBetween: 30,
  breakpoints: {
    640: {
      slidesPerView: 3,
    },
  },
  navigation: {
    //nextEl: '.swiper-button-next',
    //prevEl: '.swiper-button-prev',
    nextEl: '.swiper-custom-next',
    prevEl: '.swiper-custom-prev',
  },
});

new Swiper('.multi-column-gallery-carousel', {
  loop: true,
  centeredSlides: true,
  slidesPerView: 1,
  spaceBetween: 30,
  breakpoints: {
    640: {
      slidesPerView: 3,
    },
  },
  navigation: {
    nextEl: '.swiper-custom-next',
    prevEl: '.swiper-custom-prev',
  },
});

new Swiper('.offCenter-carousel', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 30,
  breakpoints: {
    641: {
      slidesPerView: 4,
    },
  },
  navigation: {
    nextEl: '.swiper-custom-next',
    prevEl: '.swiper-custom-prev',
  },
});

new Swiper('.event-detail-carousel', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 30,
  navigation: {
    nextEl: '.swiper-custom-next',
    prevEl: '.swiper-custom-prev',
  },
});

const masonry = new Masonry('[data-masonry]', {
  columnWidth: '.item-width',
  itemSelector: '.item',
  percentPosition: true,
  gutter: 0,

  // Don't fire the layout on init
  initLayout: false,
});

// Fire the layout after images are loaded
ImagesLoaded('[data-masonry]', function() {
  masonry.layout();
});

const theme = () => {
  document.querySelectorAll("[data-swiper]").forEach((el) => {
    let args = {
      loop: true,
      onAny(event, args) {
        el.dispatchEvent(
          new CustomEvent(event, {
            detail: { ...args },
            bubbles: true,
          })
        );
      },
    };

    if (el.dataset.swiper) {
      Helpers.extend(args, JSON.parse(el.dataset.swiper));
    }

    new Swiper(el, args);
  });

  window.dispatchEvent(new Event('themeReady'));
};

if (typeof wp !== "undefined") {
  window.onload = () => theme(); // backend
} else {
  theme(); // frontend
}
